<app-navbar></app-navbar>

<section class="bg-primary-alt header-inner o-hidden pt-7">
  <div class="container">
    <!-- <div class="row my-3">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="index.html">Home</a>
            </li>
            <li class="breadcrumb-item">
              <a href="#">Pages</a>
            </li>
          </ol>
        </nav>
      </div>
    </div> -->
    <div class="row pt-5 py-5 justify-content-start align-items-center layer-2">
      <div class="col-xl-8 col-lg-10">
        <h1 class="display-4">Projetos</h1>
        <p></p>
      </div>
    </div>
  </div>
  <div class="decoration top right scale-2 d-none d-lg-block" data-jarallax-element="-200"
    style="z-index: 0; transform: translate3d(0px, -129.205px, 0px);">
    <svg xmlns="http://www.w3.org/2000/svg" width="298" height="197" viewBox="0 0 298 197" fill="none"
      class="injected-svg bg-primary" data-src="assets/img/decorations/deco-blob-2.svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <path
        d="M271.518 116.857C266.116 125.511 259.584 133.287 253.194 141.164C248.36 147.125 243.548 153.103 238.583 158.953C236.134 161.84 233.362 164.453 230.733 167.185C229.881 168.072 228.921 168.871 228.172 169.833C225.727 172.979 222.572 175.452 220.145 178.651C217.581 182.032 213.84 184.145 210.204 186.288C201.958 191.145 193.024 193.809 183.61 195.366C174.13 196.932 164.633 196.987 155.102 196.749C148.211 196.575 141.723 194.466 135.547 191.72C126.522 187.704 117.201 184.554 107.795 181.695C102.133 179.974 96.211 179.015 90.348 178.072C82.455 176.801 74.483 176.021 66.59 174.748C61.49 173.924 56.395 173.656 51.27 173.844C41.399 174.205 31.62 172.856 21.799 172.319C17.233 172.069 12.623 171.329 8.32199 169.428C3.47399 167.289 0.64998 163.86 0.50198 158.356C0.33398 152.055 1.14497 145.872 2.36097 139.725C4.05597 131.147 6.94698 122.92 9.63998 114.625C11.435 109.1 14.044 104.068 17.138 99.191C20.263 94.261 22.833 88.964 26.156 84.181C28.943 80.169 32.218 76.415 35.73 73.013C39.232 69.62 43.835 67.853 48.488 66.47C49.535 66.159 50.73 66.247 51.851 66.298C56.263 66.493 60.572 67.214 64.898 68.22C71.472 69.749 77.906 72.04 84.709 72.466C87.564 72.646 90.438 72.616 93.301 72.558C98.117 72.46 102.93 72.236 107.746 72.117C113 71.986 117.902 70.75 122.18 67.582C129.756 61.973 137.328 56.355 144.856 50.678C150.336 46.543 155.829 42.416 161.157 38.088C167.837 32.662 174.261 26.918 180.968 21.529C186.708 16.916 192.419 12.265 198.823 8.50796C202.481 6.35996 206.471 5.08997 210.255 3.29897C212.142 2.40397 214.415 2.16795 216.544 1.97295C222.355 1.43795 228.177 0.931955 234.007 0.701955C239.169 0.498955 244.191 1.50895 249.097 3.18795C256.88 5.85395 264.337 9.12595 271.404 13.417C275.808 16.089 280.133 18.696 283.58 22.601C285.338 24.591 287.455 26.2709 289.187 28.2829C296.781 37.0899 298.767 47.203 296.302 58.465C295.044 64.211 293.189 69.723 290.986 75.139C287.625 83.399 284.443 91.746 280.726 99.846C278.041 105.691 274.613 111.197 271.518 116.857ZM95.393 132.113C95.569 132.066 95.745 132.021 95.92 131.974C95.768 131.382 95.617 130.788 95.465 130.197C95.283 130.244 95.102 130.291 94.922 130.338C95.078 130.93 95.236 131.521 95.393 132.113ZM225.68 158.404C225.83 158.343 225.985 158.293 226.121 158.211C226.142 158.199 226.103 157.986 226.062 157.977C225.916 157.94 225.755 157.948 225.601 157.938C225.627 158.092 225.652 158.248 225.68 158.404Z"
        fill="black"></path>
    </svg>
    <div id="jarallax-container-0"
      style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; overflow: hidden; z-index: -100;">
      <div
        style="pointer-events: none; transform-style: preserve-3d; backface-visibility: hidden; will-change: transform, opacity; position: fixed;">
      </div>
    </div>
  </div>
</section>


<section class="pt-5">
  <div class="container">
    <div class="row">

      <div class="col-6 col-md-4 col-lg-3 aos-init aos-animate pb-5" *ngFor="let p of projects" data-aos="fade-up"
        data-aos-delay="100">
        <a routerLink="{{ PathRoutes.ProjectDetails + '/' + p.id }}"
          class="card shadow-3d hover-shadow-3d bg-app justify-content-center align-items-center bg-primary">
          <h1 class="display-1 mb-0">
            <i class="fas fa-rocket text-white"></i>
          </h1>
        </a>
        <h3>
          {{p.title}}
        </h3>

        <a routerLink="{{ PathRoutes.ProjectDetails + '/' + p.id }}">
          Ver mais
        </a>
      </div>

      <div class="col-6 col-md-4 col-lg-3 aos-init aos-animate pb-5" data-aos="fade-up" data-aos-delay="100">
        <a href="http://phurshell.com/pages/calculator" target="_blank"
          class="card shadow-3d hover-shadow-3d bg-app justify-content-center align-items-center bg-light">
          <h1 class="display-1 mb-0">
            <i class="fas fa-plus"></i>
          </h1>
        </a>
        <h3>
          Novo projeto
        </h3>
        <p>
        </p>
      </div>
    </div>
  </div>
</section>





<app-footer></app-footer>
